module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAUCAYAAABSx2cSAAABFElEQVR42mL8//8/AwwIRC2NAlK2QIwQRAVMQHwTiCd9WBb9lwVN0hWIExgIA5AlpozINhMDgK7TBlJXgLiHkT9yyXqQINAZgSQYcAFIiYKc7Q/E3xhIA++BmAuk+QkQfydRMxsQ/wGF3h8GMgFIMyMlmhlGoGZGPGkZF/gH0gfSzEymZhZQIrkFxE7AJHcHahBy1P3HEpW/gVgJiDeDNLMC8Q8gfoim8C8Q3wBiMVA6RjMQJMYG0qwJUgTMGM5YMgAoi54Ayn1GE98OpLRgoS2ARSMHkNoFxNVY/CwOcjFI8yQgVgAqNkSWBdoG8ooqELeiGaoOpEBq14ILA6DAcSDHAosNT4GYH4h50MRBhYEBQIABAFgSRx9/0ho3AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/h111.png
// module id = i1Yp
// module chunks = 0